import * as yup from 'yup';
import getIsRequiredText from 'functions/validation/getIsRequiredText';

export const editUserFormModalSchema = yup.object().shape({
    name: yup.string().required(getIsRequiredText('Name')),
    country: yup.string().required(getIsRequiredText('Country')).min(2),
    organisation: yup.string().required(getIsRequiredText('Organisation')),
});
